/* SET STATE */
export const SET_STATE_LABAREA = "SET_STATE_LABAREA"

/* LAB AREAS */
export const GET_LABAREAS = "GET_LABAREAS"
export const GET_LABAREAS_SUCCESS = "GET_LABAREAS_SUCCESS"
export const GET_LABAREAS_FAIL = "GET_LABAREAS_FAIL"

/* LAB AREA */
export const GET_LABAREA = "GET_LABAREA"
export const GET_LABAREA_SUCCESS = "GET_LABAREA_SUCCESS"
export const GET_LABAREA_FAIL = "GET_LABAREA_FAIL"

/**
 * ADD LAB AREA
 */
 export const ADD_NEW_LABAREA = "ADD_NEW_LABAREA"
 export const ADD_LABAREA_SUCCESS = "ADD_LABAREA_SUCCESS"
 export const ADD_LABAREA_FAIL = "ADD_LABAREA_FAIL"

 /**
 * UPDATE LAB AREA
 */
export const UPDATE_LABAREA = "UPDATE_LABAREA"
export const UPDATE_LABAREA_STATUS = "UPDATE_LABAREA_STATUS"
export const UPDATE_LABAREA_SUCCESS = "UPDATE_LABAREA_SUCCESS"
export const UPDATE_LABAREA_FAIL = "UPDATE_LABAREA_FAIL"

/**
 * DELETE LAB AREA
 */
export const DELETE_LABAREA = "DELETE_LABAREA"
export const DELETE_LABAREA_SUCCESS = "DELETE_LABAREA_SUCCESS"
export const DELETE_LABAREA_FAIL = "DELETE_LABAREA_FAIL"
